module.exports = __webpack_public_path__ + "assets/img/Collected.89e9e80c.png";